import cx from 'classnames'

import type { Severity } from './types'

export const severityColorForegroundStyles = (
  status: Severity,
  isExtraContrast?: boolean,
) =>
  cx(
    {
      error: isExtraContrast
        ? 'text-black dark:text-error-50'
        : 'text-error-500',
      warning: isExtraContrast
        ? 'text-black dark:text-warning-50'
        : 'text-warning-500',
      info: isExtraContrast ? 'text-black dark:text-info-50' : 'text-info-500',
      success: isExtraContrast
        ? 'text-black dark:text-success-50'
        : 'text-success-500',
    }[status],
  )

export const severityColorStyles = (status: Severity) =>
  cx(
    severityColorForegroundStyles(status, true),
    {
      error: 'bg-error-400 dark:bg-error-600 ',
      warning: 'bg-warning-400 dark:bg-warning-600 ',
      info: 'bg-info-400 dark:bg-info-600 ',
      success: 'bg-success-400 dark:bg-success-600 ',
    }[status],
  )
